const initialState = {
  data: [],
  loading: false,
  error: null,
};

export default function retailDevicesReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_RETAIL_DEVICES_PENDING':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'GET_RETAIL_DEVICES_SUCCESS':
      return {
        ...state,
        loading: false,
        data: Array.isArray(action.data) ? action.data : [],
      };
    case 'GET_RETAIL_DEVICES_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
        data: [],
      };
    default:
      return state;
  }
}
